// extracted by mini-css-extract-plugin
export default {"inputsBox":"ResetPasswordCRMForm_inputsBox__XLVHR","submitButtonBox":"ResetPasswordCRMForm_submitButtonBox__+xqaE"};